<template>
  <div>
    <div class="text-black">
      <BCol
        md="12"
        class="d-flex gap-10 w-100 p-0 my-[24px]"
      >
        <div class="d-flex ml-auto rounded-lg align-items-center border search-bar">
          <span
            class="k-search-normal-1 h-100 font-bold text-10 pt-[7px] align-middle mx-[5px]"
          />
          <BFormInput
            v-model="keyword"
            placeholder="Cari nama talent lead, talent, id talent"
            class="border-0"
            @input="handleSearch()"
          />
        </div>
        <b-dropdown
          id="dropdown-1"
          class="filter"
          no-caret
          right
          variant="primary"
          toggle-class="text-decoration-none toggle-custom button-primary rounded-lg py-0 px-1"
        >
          <h5>Filter</h5>
          <template #button-content>
            <b-img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
              class="height-[20px]"
            />
          </template>
          <b-dropdown
            id="dropdown-3"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            right
            no-caret
            dropright
          >
            <template #button-content>
              <span class="hover-salmon text-6 w-100">Status</span>
            </template>
            <b-dropdown-form style="width: 200px">
              <b-form-checkbox
                v-for="(statue, index) in listStatus"
                :key="index"
                v-model="filterStatusSelected"
                :name="`checkbox-${index}`"
                class="text-6 mb-1"
                :value="statue.value"
                @change="getListTalent()"
              >
                {{ statue.text }}
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>
          <b-dropdown
            id="dropdown-2"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            right
            no-caret
            dropright
          >
            <template #button-content>
              <span class="hover-salmon text-6 w-100">Skill role</span>
            </template>
            <b-dropdown-form style="width: 200px">
              <b-form-checkbox
                v-for="(skills, index) in listSkills"
                :key="index"
                v-model="filterSelected"
                :name="`checkbox-${index}`"
                class="text-6 mb-1"
                :value="skills.id"
                @change="getListTalent()"
              >
                {{ skills.name }}
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>
          <h5
            class="pb-0 pt-1 font-bold text-danger w-100 cursor-pointer"
            @click="resetFilter()"
          >
            Reset filter
          </h5>
        </b-dropdown>
      </BCol>
    </div>
    <BOverlay
      id="scroll"
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="table"
        style="height: calc(100vh - 340px); overflow-y: scroll"
        @scroll="handleScroll"
      >
        <BTable
          :items="items"
          :fields="fields"
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          show-empty
          sort-icon-right
          tbody-tr-class="hover:bg-slate-100 transition-colors duration-300 cursor-pointer"
          @row-clicked="(item, _, e) => $router.push({ name: $route.meta.routeDetail, params: { id: item.talent_id } })"
        >
          <template #cell(full_name)="data">
            <div>
              {{ data.item.full_name }}
            </div>
            <div class="text-[#828282]">
              {{ data.item.talent_id }}
            </div>
          </template>
          <template #cell(talent_lead)="data">
            <div>
              {{ data.item.talent_lead || '-' }}
            </div>
          </template>
          <template #cell(action)="data">
            <div class="flex justify-end items-center">
              <BButton
                class="btn-icon p-0"
                size="sm"
                variant="flat-warning"
                :to="{ name: $route.meta.routeDetail, params: { id: data.item.talent_id } }"
                tag="router-link"
              >
                <span class="k-arrow-right text-[#08A0F7] text-3xl" />
              </BButton>
            </div>
          </template>
        </BTable>
      </div>
    </BOverlay>
  </div>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { alertError } from '@toast'
import { tableRequestEdit } from '../config'

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      items: [],
      limit: 20,
      offset: 0,
      fields: tableRequestEdit,
      lastData: false,
      keyword: '',
      filterSelected: [],
      filterStatusSelected: [],
      listSkills: [],
      alertError,
      listStatus: [
        {
          text: 'Register',
          value: 'registered',
        },
        {
          text: 'Selected',
          value: 'selected',
        },
        {
          text: 'Hired',
          value: 'hired',
        },
        {
          text: 'Non-job',
          value: 'non job',
        },
      ],
    }
  },
  computed: {
    skill() {
      return this.filterSelected.join(',')
    },
    status() {
      return this.filterOffSelected.join(',')
    },
  },
  mounted() {
    this.getListTalent()
    this.getListSkills()
  },
  methods: {
    handleScroll() {
      const table = document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight
        && !this.loading
        && !this.lastData
      ) {
        this.getNextData()
      }
    },
    async getListTalent() {
      this.loading = true
      this.offset = 0
      const params = `offset=${this.offset}&limit=${this.limit}&search=${this.keyword}&status=${this.filterStatusSelected.join(',')}&role=${this.filterSelected.join(',')}&type=request`
      const url = `v1/talent_update?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data } = res.data
          this.items = data
          this.offset = data.length

          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
    },
    async getNextData() {
      this.loading = true
      if (!this.lastData) {
        const params = `offset=${this.offset}&limit=${this.limit}&search=${this.keyword}&status=${this.filterStatusSelected.join(',')}&role=${this.filterSelected.join(',')}&type=request`
        const url = `v1/talent_update?${params}`

        await komtimAxiosIns
          .get(url)
          .then(res => {
            const { data } = res.data
            this.items.push(...data)
            this.offset += data.length
            this.loading = false
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(err => {
            this.alertError(err)
          })
      }
    },
    handleSearch: _.debounce(function search() {
      this.getListTalent()
    }, 1000),
    selectItem(id) {
      this.idItem = id
    },
    async getListSkills() {
      this.loading = true
      this.offset = 0
      const params = `active=${true}&type=2`
      const url = `v1/skills/resource?${params}`

      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data } = res.data
          this.listSkills = data
        })
        .catch(err => {
          this.alertError(err)
          this.loading = false
        })
    },
  },
}
</script>
<style scoped lang="scss">

.selected {
  background: #dcf3eb;
  border-radius: 4px;
  color: #34a770;
  font-weight: 500;
  font-size: 14px;
  padding: 3px 10px;
  width: 100%;
}
</style>
